import { Account } from '../account/account';
import { PermissionAction } from '../permission/permissions.model';
import { Voice } from './voice';

export interface User {
    id?: string;
    bleIds?: number[];
    firstName?: string;
    lastName?: string;
    email?: string;
    secret?: string;
    accountIds?: string[];
    companyId?: string;

    loginAttempts?: number;
    blockedUntil?: Date;
    lastLogin?: Date;
    lastBadgeRefresh?: number;
    push?: PushIdentifier[];

    badges?: UserBadge;
    badge?: number;

    // QR Login
    pinHash?: string;

    phone?: string;
    middleName?: string;
    avatarFile?: string;

    locale?: string;
    /** Optional second language the user speaks; never equal to `locale`. */
    secondaryLocale?: string;
    /** Voice others hear for this user's read-aloud messages; unset means `DEFAULT_VOICE`. */
    voice?: Voice;
    dialect?: string;
    birthDate?: string;
    aboutMe?: string;
    address?: Address;
    awaitingUserOwnership?: boolean; // For invited users...do not return users for calls who have not "taken ownership" not click on link or anything
    simulator?: boolean;
    canary?: boolean;
    enabledActions?: PermissionAction[];

    /** List of account IDs the user has been removed from */
    removedAccountIds?: string[];

    updated?: Date;
    metaphones?: {
        firstName: string[];
        lastName: string[];
        fullName: string[];
    };
}

export interface AuthenticatedUser {
    accountId?: string;
    userId?: string;
    personId?: string;
    apiKeyId?: string;
    companyId?: string;
    accountIds?: string[];
    key?: string;
    facilityId?: string;
}

export enum PushType {
    apn = 'apn',
    apnVoip = 'apn-voip',
    apnVoipPtt = 'apn-voip-ptt',
    apnVoipNonPtt = 'apn-voip-non-ptt',
    gcm = 'gcm',
    vapid = 'vapid',
    vapidRadio = 'vapid-radio',
}

export interface PushIdentifier {
    id?: string;
    type: PushType;
    identifier?: string;
}

export interface UserBadge {
    messages?: number;
    alerts?: number;
}

export interface Address {
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    country?: string;
    zip?: string;
}

export interface TeamsIdentity {
    id: string;
    accountId: string;
    tenantId: string;
}

export interface LoggedInUser {
    id?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    aboutMe?: string;
    email?: string;
    phone?: string;
    lastLogin?: string;
    locale?: string;
    /** Optional second language the user speaks; never equal to `locale`. */
    secondaryLocale?: string;
    /** Voice others hear for this user's read-aloud messages; unset means `DEFAULT_VOICE`. */
    voice?: Voice;
    dialect?: string;
    accounts?: Account[];
    avatarFile?: string;
    company?: any;
    enabledActions?: PermissionAction[];
    acsUserId?: string;
    teamsOnlyUser?: boolean;
}

export interface UpdateUser {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    aboutMe?: string;
    avatarFile?: string;
    locale?: string;
    /** Optional second language; `null` clears it and absent leaves it unchanged. */
    secondaryLocale?: string | null;
    /** Voice for read-aloud messages; `null` clears it back to the default and absent leaves it unchanged. */
    voice?: Voice | null;
    birthDate?: string;
    address?: Address;
    email?: string;
    phone?: string;
}

export interface UserQrLogin {
    qr: string;
    token: string;
    hasPin: boolean;
}

export interface UserProfile {
    id?: string;
    personId?: string;
    avatarFile?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    aboutMe?: string;
    phone?: string;
    email?: string;
    locale?: string;
    /** Optional second language the user speaks; never equal to `locale`. */
    secondaryLocale?: string;
    /** Voice others hear for this user's read-aloud messages; unset means `DEFAULT_VOICE`. */
    voice?: Voice;
    birthDate?: string;
    address?: Address;
    badges?: UserBadge;
    companyId?: string;
    teamsId?: TeamsIdentity;
}
